export const profileHeaders = [
  {
    key: "businessName",
    label: "Business Name",
  },
  {
    key: "primaryContactName",
    label: "Primary Contact Name",
  },
  {
    key: "businessType",
    label: "Business Type",
  },
  {
    key: "businessEmail",
    label: "Business Email",
  },

  {
    key: "businessPhone",
    label: "Business Phone",
  },
];


export const providerProfileFilterOptions = [
  {
    label: "Business Name",
    value: "businessName",
    type: "text",
  },
  {
    label: "Business Type",
    value: "businessType",
    type: "checkbox",
    options: [
      {
        value: "Funeral & Memorial Service Providers",
        label: "Funeral & Memorial Service Providers",
      },
      {
        value: "Aftercare & Grief Support",
        label: "Aftercare & Grief Support",
      },
      {
        value: "Transportation & Logistics",
        label: "Transportation & Logistics",
      },
      { value: "Products & Supplies", label: "Products & Supplies" },
      {
        value: "Cremation Services",
        label: "Cremation Services",
      },
      { value: "Technology & Media", label: "Technology & Media" },
      {
        value: "Religious & Cultural Services",
        label: "Religious & Cultural Services",
      },
      {
        value: "Vendor Services",
        label: "Vendor Services",
      },
    ],
  },
];
